import { array, object, string, TypeOf, union } from 'zod';

import { ExternalLink, InternalLink, SystemLink } from './common';

/* ------------------------------- MenuElement ------------------------------ */

export const MenuElement = object({
    name: string(),
    pageId: string(),
});

export type MenuElement = TypeOf<typeof MenuElement>;

/* ----------------------------- SystemMenuLink ----------------------------- */

const SystemMenuLink = SystemLink.extend({ linkGroupId: string() });
export type SystemMenuLink = TypeOf<typeof SystemMenuLink>;

/* ---------------------------- InternalMenuLink ---------------------------- */

const InternalMenuLink = InternalLink.extend({ linkGroupId: string() });
export type InternalMenuLink = TypeOf<typeof InternalMenuLink>;

/* ---------------------------- ExternalMenuLink ---------------------------- */

const ExternalMenuLink = ExternalLink.extend({ linkGroupId: string() });
export type ExternalMenuLink = TypeOf<typeof ExternalMenuLink>;

/* -------------------------------- MenuLink -------------------------------- */

export const MenuLink = union([
    SystemMenuLink,
    InternalMenuLink,
    ExternalMenuLink,
]);
export type MenuLink = TypeOf<typeof MenuLink>;

/* --------------------------------- MenuV1 --------------------------------- */

export const MenuV1 = object({
    elements: array(MenuElement),
    extend: object({
        pages: array(
            object({
                reference: string(),
                id: string(),
            }),
        ),
    }).optional(),
});

export type MenuV1 = TypeOf<typeof MenuV1>;

/* ---------------------------------- Menu ---------------------------------- */

export const Menu = object({
    links: array(MenuLink),
    extend: object({
        pages: array(
            object({
                reference: string(),
                id: string(),
            }),
        ),
    }).optional(),
});
export type Menu = TypeOf<typeof Menu>;
